import './InputFileAvulso.css';

import { Loading } from '@elotech/components';
import { useLoading } from 'common/hooks';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ArquivoService, ProcessoArquivoService } from 'service';
import { getConfigSelector } from 'state';
import { ArquivoDTO, Config } from 'types';

type Props = {
  arquivo?: ArquivoDTO;
  onChangeFile: (arquivo?: ArquivoDTO) => void;
  onBusyChange?: (busy: boolean) => void;
};

export const InputFileAvulso = ({
  arquivo,
  onBusyChange,
  onChangeFile
}: Props) => {
  const [loading, setLoading] = useLoading();
  const config = useSelector(getConfigSelector) as Config;
  const id = useMemo(
    () => `file-${Math.random().toString(36)}-${new Date().getTime()}`,
    []
  );

  useEffect(() => {
    onBusyChange?.(loading);
  }, [loading, onBusyChange]);

  const doChangeFile = async (file: File | undefined) => {
    if (!file) {
      onChangeFile(undefined);
      return;
    }

    const isCloud = config.isFileCloud;
    const arquivoDto = await ProcessoArquivoService.fileToArquivoDocumento(
      file,
      isCloud,
      false
    );

    onChangeFile(arquivoDto);
  };

  return (
    <div className="file-uploader">
      <Loading loading={loading} contain />
      <input
        type="file"
        id={id}
        className="file-uploader-input"
        onChange={event =>
          event?.target.files?.[0] &&
          setLoading(doChangeFile(event.target.files[0]))
        }
        title="Clique ou arraste para anexar"
      />

      <label
        className="input"
        htmlFor={id}
        data-title={
          loading ? 'Carregando...' : arquivo?.nome || 'Selecione um arquivo'
        }
      />

      <div className="file-uploader-icon" />
      {arquivo?.id && (
        <>
          <div
            className="file-downloader-icon"
            onClick={() =>
              setLoading(
                ArquivoService.downloadByEloArquivo(arquivo.id, arquivo.nome)
              )
            }
          />
          <div
            className="file-remove-icon"
            onClick={() => doChangeFile(undefined)}
          />
        </>
      )}
    </div>
  );
};
